import { writeContractApi } from "../api/methods-marketplace";
import wbnbABI from "./../abis/wbnb.json";
import { encodeFunctionData } from "viem";
import { addToast } from "@heroui/react";

const TriggerPurchaseProcess = async ({
  erc20BAFAddress,
  transferProxyAddress,
  formattedTotalValue,
  setApprovalStatus,
  refreshBalance = () => {},
  fetchNftData = () => {},
  publicClient = null
}) => {
  try {
    setApprovalStatus("process");

    const encodedData = await encodeFunctionData({
      abi: wbnbABI,
      functionName: "approve",
      args: [transferProxyAddress, formattedTotalValue]
    });

    const result = await writeContractApi({
      address: erc20BAFAddress,
      encoded_data: encodedData
    });

    if (!result?.data?.tx_hash) {
      console.error("No tx_hash in result:", result);
      throw new Error("Transaction hash not received");
    }

    const transaction_hash = result.data.tx_hash;

    await new Promise((resolve) => setTimeout(resolve, 5000));

    const testResult = publicClient.waitForTransactionReceipt({
      hash: transaction_hash
    });

    if (testResult?.status === 200 || result?.status === 200) {
      addToast({
        title: "Approval Successful!",
        description: "NFT Approval Successful!",
        color: "success",
        variant: "bordered"
      });
      setApprovalStatus("done");
      await refreshBalance();
      fetchNftData();
    } else {
      addToast({
        title: "Failed",
        description:
          testResult?.message || result?.message || "Transaction failed",
        color: "danger",
        variant: "bordered"
      });
      setApprovalStatus("yetToStart");
    }
  } catch (error) {
    setApprovalStatus("yetToStart");
    console.error("🚀 ~ triggerPurchaseProcess ~ error:", error);
    console.error("Error full object:", JSON.stringify(error, null, 2));

    if (error.response) {
      console.error("Error status:", error.response.status);
      console.error(
        "Error data:",
        JSON.stringify(error.response.data, null, 2)
      );
      console.error("Error headers:", error.response.headers);
    }

    addToast({
      title: "Error",
      description:
        error?.response?.data?.message || error?.message || "An error occurred",
      color: "danger",
      variant: "bordered"
    });
  }
};

export default TriggerPurchaseProcess;
